import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { BasePage } from '../../base.page';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { Platform, LoadingController, ToastController } from '@ionic/angular';

@Component({
  selector: 'shc-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
})
export class ResetPasswordPage extends BasePage implements OnInit {
  email: string;

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController);
    this.route.params.subscribe(res => {
      this.email = this.router.getCurrentNavigation().extras?.state?.email;
    });
  }

  ngOnInit() { }

  ionViewWillEnter() { }

  onPinCodeComplete(value) {
    console.log(value);
    this.router.navigate(['/auth/newpassword'], { state: { code: value, email: this.email } });
  }

  resendCode() {
    this.authService.forgot({ email: this.email }).subscribe(res => {
      this.showToast(this.translate.instant(marker('Auth.ResentCode'), { email: this.email}));
      console.log(res);
    }, error => {
      this.errorService.handle(error);
    });
  }

}
